import React from 'react';
import { FiMapPin, FiPhone, FiMail } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import { GiWheat, GiThreeLeaves, GiPlantRoots } from 'react-icons/gi';
import { FaLeaf } from 'react-icons/fa';
import Reveal from '../Reveal/Reveal';
import { CONTACT } from '../../data/content';
import '../../styles/contact.css';

const DECOR = [
  { Icon: FaLeaf, cls: 'c1' },
  { Icon: GiWheat, cls: 'c2' },
  { Icon: GiThreeLeaves, cls: 'c3' },
  { Icon: GiPlantRoots, cls: 'c4' },
];

export default function Contact() {
  return (
    <section id="contact" className="section section-alt contact">
      <div className="contact__decor" aria-hidden="true">
        {DECOR.map(({ Icon, cls }) => (
          <Icon key={cls} className={`contact__leaf ${cls}`} />
        ))}
      </div>

      <div className="container">
        <Reveal className="section-head">
          <h2 className="section-title">Let's grow something good together</h2>
          <p className="section-subtitle">
            Reach out to us — we're always happy to hear from you.
          </p>
        </Reveal>

        <Reveal className="contact__card">
          <div className="contact__map">
            <iframe
              title="Mahizh Natural Farm location"
              src={`https://www.google.com/maps?q=${CONTACT.lat},${CONTACT.lng}&z=15&output=embed`}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>

          <div className="contact__info">
            <ul className="contact__details">
              <li>
                <span className="contact__icon">
                  <FiMapPin />
                </span>
                <div>
                  <strong>Address</strong>
                  <p>
                    <a
                      href={`https://www.google.com/maps?q=${CONTACT.lat},${CONTACT.lng}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {CONTACT.address}
                    </a>
                  </p>
                </div>
              </li>
              <li>
                <span className="contact__icon">
                  <FiPhone />
                </span>
                <div>
                  <strong>Phone</strong>
                  <p>
                    <a href={CONTACT.phoneHref}>{CONTACT.phone}</a>
                    <br />
                    <a href={CONTACT.phone2Href}>{CONTACT.phone2}</a>
                  </p>
                </div>
              </li>
              <li>
                <span className="contact__icon">
                  <FiMail />
                </span>
                <div>
                  <strong>Email</strong>
                  <p>
                    <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
                  </p>
                </div>
              </li>
            </ul>

            <a
              href={`https://wa.me/${CONTACT.whatsapp}`}
              className="btn contact__whatsapp"
              target="_blank"
              rel="noreferrer"
            >
              <FaWhatsapp /> Chat on WhatsApp
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
